module.exports = __webpack_public_path__ + "static/media/mealshare-app_2screen.175c3705.png";